import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { ProposalStatus } from 'src/app/models/enum/proposal-status.enum';
import { Job } from 'src/app/models/job.model';
import { BoardProposalItem, CustomerProposalItem, IProposalItem } from 'src/app/models/proposal/proposal.model';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import * as moment from 'moment';
import { ProposalService } from 'src/app/services/sections/job/proposal.service';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { GenericModalComponent } from '../../generic-modal/generic-modal.component';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';

@Component({
	selector: 'proposals-queue',
	templateUrl: './proposals-queue.component.html',
	styleUrls: ['./proposals-queue.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class ProposalsQueueComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('actionForbiddenModal') public actionForbiddenModal: GenericModalComponent;

	public readonly ButtonIcons = ButtonIcons;
	public readonly ProposalStatus = ProposalStatus;
	public readonly PageType = PageType;
	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;

	public moment = moment;
	public self = this;

	public job: Job;
	public customerPreferences: SettingsPreferences;
	public proposals: BoardProposalItem[];
	public pageType: PageType;

	public canSubmitProposal = false;

	public itemDetailsReturnUri = null;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private proposalService: ProposalService
	) { }

	ngOnInit(): void {
		this.pageType = this.activatedRoute.snapshot.data.pageType;
		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences as SettingsPreferences;
		this.itemDetailsReturnUri = this.router.url;

		if (this.pageType === PageType.BoardMember) {
			this.proposals = (this.activatedRoute.snapshot.data.proposals || [])
				.map(proposal => Object.assign(new BoardProposalItem(), proposal));

			this.itemDetailsReturnUri = [...this.proposals.find(p => p.isCurrentProposal())?.smartSyncUri?.split('/') ?? ''].join('/');
		} else {
			this.proposalService.canPropose(TokenHelper.getToken(this.activatedRoute))
				.subscribe((result) => this.canSubmitProposal = !!result);

			this.proposals = ((this.activatedRoute.snapshot.data.proposals || []) as BoardProposalItem[])
				.map((proposal: BoardProposalItem) => Object.assign(new CustomerProposalItem(), proposal));
		}
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public getProposalItemClass(proposal: any): string {
		let cssClass = `proposal ${proposal.status.toLowerCase()}`;
		if (this.highlightItem(proposal)) {
			cssClass = `${cssClass} current`;
		}
		return cssClass;
	}

	public onNewRequest(): void {
		if (this.canSubmitProposal) {
			this.router.navigate(['create'], { relativeTo: this.activatedRoute });
		} else {
			this.actionForbiddenModal.open();
		}
	}

	public highlightItem(proposal: any): boolean {
		return proposal != null && proposal.isCurrentProposal != null && proposal.isCurrentProposal();
	}

	public navigateToItemDetails(proposal: IProposalItem): void {
		proposal.navigate(this.router, this.activatedRoute, this.itemDetailsReturnUri);
	}

	public navigateWithData(page, data): void {
		this.router.navigate([page], { relativeTo: this.activatedRoute.parent, state: data });
	}

	ngOnDestroy(): void {
	}
}
